<template>

    <div class="py-3">
        <div class="d-flex justify-content-between mb-4">
            <div>
                <router-link class="back-route h3" ref="backBtn" @click="backHandler" :to="isFull ? '#':'/competitions'">
                    <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                    Create Competition
                </router-link>
            </div>
            <div class="d-flex justify-content-center">
                <button @click.prevent="SaveCompetition" v-if="permissions.includes('create competition')" :class="[{notAllowed:errorBtnSubmit}]" class="btn-container" ref="buttonSaveData">Save Competition</button>
            </div>
        </div>

        <div class="d-flex flex-column gap-3">
            <div id="createUserContainer" class="tabcontent1">
                <div class="row col-12">
                    <div class="col-md-4">
                        <label for="inputName" class="form-label">Name<span style="color: red">*</span></label>
                        <input type="text" @input="checkName"
                                    v-model="competition.name" class="custom-input form-control" id="inputName" placeholder="Name">
                        <span class="errFront text-danger" v-if="errorFront">*Required</span>
                        <div class="err" v-if="errors['name'].length > 0" style="position: absolute;">
                            <div v-for="msg in errors['name']" class="text-danger">{{msg}}</div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Template to Use<span style="color: red">*</span></label>
                        <Multiselect
                                v-model="competition.template_id"
                                :options="templates"
                                @change="checkTemplate"
                                @close="clearTemplate"
                                id="template_id1"
                                placeholder="Template to Use"
                                ref="templateRefs"
                        />
                        <span class="errFront text-danger" v-if="errorFront2">*Required</span>
                    </div>
                    <div class="col-md-2 d-flex align-items-end">
                        <router-link v-if="permissions.includes('create template')" to="/templates/create" style="color: #e65c00;">
                            <span style="color: #e65c00;">Add Template</span>
                        </router-link>
                    </div>
                    <div class="col-md-3">
                        <label for="template_id2" class="form-label">Participant Type<span style="color: red">*</span></label>
                        <select id="template_id2" @change="checkParticipantType" class="form-select" v-model="competition.participant_type">
                            <option value="null" disabled selected>Choose Participant Type</option>
                            <option value="individual">Individual</option>
                            <option value="team">Team</option>
                        </select>
                        <span class="errFront text-danger" v-if="errorFront3">*Required</span>
                    </div>
                </div>
            </div>

            <div id="createUserContainer2" class="tabcontent2">
                <div class="row col-12">
                    <div class="col-md-6 styleCssMargin">
                        <label for="inputName" class="form-label">Competition Time</label>
                        <div class="d-flex cssRangDates">
                            <div class="form-check w-50">
                                <input class="form-check-input" type="radio" name="flexRadioDefault1" id="flexRadioDefault1" @click="showRangeDates" v-model="competition.date_type" value="1" checked>
                                <label class="form-check-label" for="flexRadioDefault1">
                                    Range of Dates
                                </label>
                            </div>
                            &nbsp;&nbsp;&nbsp;
                            <div class="form-check w-50">
                                <input class="form-check-input" type="radio" name="flexRadioDefault2" id="flexRadioDefault2" v-model="competition.date_type" value="2" @click="showSpecificDates">
                                <label class="form-check-label" for="flexRadioDefault2">
                                    Specific Date and Time
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- specific dates -->
                    <div class="col-md-12 d-flex styleInIPad" v-if="isActivatedSpecific === true">
                        <div class="col-xl-3 col-md-4">
                            <h4>Select Date</h4>
                            <div>
                                <label>End Date<span style="color: red">*</span></label>
                                <Datepicker format="MM/dd/yyyy" @update:modelValue="checkDatesEndSpecific" :minDate="new Date()" v-model="competition.end_date"></Datepicker>
                                <span class="errFront text-danger" v-if="errorFront7">*Required</span>
<!--                                <input type="date" v-model="competition.end_date" class="form-control cssEndDate" :min="minToday">-->
                            </div>
                        </div>
                        <div class="col-xl-9 col-md-8">
                            <div class="allCssTime">
                                <div class="firstCssTime">
                                    <div class="d-flex position-relative">
                                        <h4>Select Time</h4>
                                        <span class="fontInfoData position-absolute">
                                            <font-awesome-icon @mouseover="showDefaultUser" @mouseleave="hideDefaultUser" class="styleDesignCircleInfo" :icon="['fas', 'circle-info']" size="lg"/>
                                        </span>
                                        <span id="defaultUser" class="designDefaultUser">Time should be save in UTC</span>
                                    </div>

                                    <label>Start Time in GMT<span style="color: red">*</span></label>
                                    <Datepicker :is24="false" @update:modelValue="setStartTime" :timePicker="true" v-model="start_time"  utc  ></Datepicker>
                                    <span class="errFront text-danger" v-if="errorFront8">*Required</span>
<!--                                    <input type="time" v-model="competition.start_time" class="form-control styleFirstTime" @input="checkTimes1">-->
                                </div>
                                <div class="secondCssTime">
                                    <label>End Time in GMT<span style="color: red">*</span></label>
                                    <Datepicker :is24="false" :timePicker="true"   @update:modelValue="setEndTime" v-model="end_time" utc ></Datepicker>
                                    <span class="errFront text-danger" v-if="errorFront9">*Required</span>
<!--                                    <input type="time" v-model="competition.end_time" class="form-control styleSecondTime" @input="checkTimes2">-->
                                </div>
                                <div class="durationSpecificCssTime">
                                    <h4>Duration</h4>
                                    <label>Duration in Minutes<span style="color: red">*</span></label>
                                    <input type="number" v-model="competition.specific_duration" class="form-control styleFirstTime" @input="preventMinusValue">
                                    <span class="errFront text-danger" style="font-size: 0.9rem" v-if="errorFront10">*Required</span>
                                    <!--                                    <input type="time" v-model="competition.start_time" class="form-control styleFirstTime" @input="checkTimes1">-->
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- range dates -->
                    <div class="col-md-12 d-flex styleInIPad" v-if="isActivatedRange === true">
                        <div class="col-md-9">
                            <h4>Select Date</h4>
                            <div class="allCssDate">
                                <div class="firstDateStyle1">
                                    <label>Start Date<span style="color: red">*</span></label>
                                    <Datepicker format="MM/dd/yyyy" :minDate="new Date()"  @update:modelValue="checkDates1" v-model="competition.start_date"></Datepicker>
                                    <span class="errFront text-danger" v-if="errorFront4">*Required</span>
<!--                                    <input type="date" v-model="competition.start_date" class="form-control cssFirstDateOne" @input="checkDates1" :min="minToday">-->
                                </div>
                                <div class="secondDateStyle2">
                                    <label>End Date<span style="color: red">*</span></label>
                                    <Datepicker :minDate="minToday" format="MM/dd/yyyy" @update:modelValue="checkDates2" v-model="competition.end_date"></Datepicker>
                                    <span class="errFront text-danger" v-if="errorFront5">*Required</span>
<!--                                    <input type="date" v-model="competition.end_date" class="form-control cssSecondDateTwo" @input="checkDates2" :min="minToday">-->
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <h4>Select Duration</h4>
                            <div class="cssDuration">
                                <label>Duration in Minutes<span style="color: red">*</span></label>
                                <input type="number" v-model="competition.duration" class="form-control styleFirstTime" @input="preventMinusValue">
                                <span class="errFront text-danger" v-if="errorFront6">*Required</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>


    <AssignUsers @clickAssign="clickAssignHandler" v-if="this.isShow" :message="confirmMessage" :confirmUsers="ChooseUsers" :confirmTeam="ChooseTeam"
                 :confirmTeamLeader="ChooseTeamLeader"/>

    <ModalChooseUser @close-modal="closeModalHandler" v-if="this.isAssignFlag"  :message="chooseMessageText" :data="data" :AssignUsers="AssignUsers" />

    <AlartModal v-if="showModal" :message="message" :imagePath="ImagePath" @close-modal="showModal = false"/>

    <ConfirmationModal v-if="isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
</template>

<script>
    import SaveBtn from '../../components/SaveBtn';
    import competition from "../../../api-services/competition";
    import changeHandler from '../../../validation/userValidation';
    import AlartModal from "../../components/AlartModal";
    import ConfirmationModal from '../../components/ConfirmationModal';
    import AssignUsers from "../../components/AssignUsers";
    import ModalChooseUser from '../../components/ModalChooseUsers';
    import {computed} from "vue";
    import repository from "../../../api-services/repository";
    import moment from 'moment';
    import Multiselect from '@vueform/multiselect';
    import Datepicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css'

    import {logger} from "../../../helpers/logger";

    export default {
        name:'create-competition',
        props:['ChooseUsers' , 'ChooseTeam' , 'ChooseTeamLeader' , 'AssignUsers'],
        components:{
            ConfirmationModal,
            Multiselect,
            AlartModal,
            SaveBtn,
            AssignUsers,
            ModalChooseUser,
            Datepicker

        },
        data(){
            return{
                changeHandler,
                errorFront:false,
                errorFront2:false,
                errorFront3:false,
                errorFront4:false,
                errorFront5:false,
                errorFront6:false,
                errorFront7:false,
                errorFront8:false,
                errorFront9:false,
                errorFront10:false,
                errorBtnSubmit:false,
                start_time: null,
                end_time: null,
                isShow:false,
                permissions:[],
                isAssignFlag: false,
                confirmModalFlag: false,
                confirmModalFlag2: false,
                isActivatedRange:true,
                isActivatedSpecific:false,
                data: [],
                minToday:'2022/01/01',
                firstTimeInDay:'00:00',
                lastTimeInDay:'23:59',
                competition: {
                    name:"",
                    type:1,
                    participant_type:null,
                    date_type: 1,
                    start_date:null,
                    end_date:null,
                    start_time:null,
                    end_time:null,
                    duration:null,
                    specific_duration:null,
                    template_id:null
                },
                errors:{
                    name:[],
                    type:[],
                    participant_type:[],
                    date_type:[],
                    start_date:[],
                    end_date:[],
                    duration:[],
                    isError: false
                },
                templates:[],
                template:null,
                ImagePath:'',
                showModal:false,
                message:null,
                errorMessages:[],
                responseErrorMessage:'',
                showErrorModal:false,
                isFull: false,
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData:{
                    name: false,
                    user_email: false,
                    host:false
                },
                confirmModal: computed(() => this.$store.state.settings.confirmModal),
                confirmMessage: '',
                chooseMessageText:''
            }
        },
        async mounted() {
            await this.$store.dispatch('activeTap', 'competition');
            this.competition.date_type = 1;
            this.errorBtnSubmit = true;
            await this.getTemplates();
            this.permissions = this.$store.state.auth.permissions;
            this.competition.template_id = this.$route.params.template_id;
            if(this.competition.template_id){
                console.log('');
            }else {
                this.competition.template_id = null;
            }

            let today = new Date().toISOString().split('T')[0];
            this.minToday = today;
        },

        methods:{
            showDefaultUser() {
                let message = document.getElementById('defaultUser');
                message.style.display = 'block';
            },

            hideDefaultUser() {
                let message = document.getElementById('defaultUser');
                message.style.display = 'none';
            },

            checkDatesEndSpecific(e){
                this.errorFront7 = false;
            },
            setStartTime (value) {
                this.errorFront8 = false;
                console.log({value})
                if(value !== null){
                    if(value.hours < 10){
                        value.hours = '0'+value.hours;
                    }

                    if(value.minutes < 10){
                        value.minutes = '0'+value.minutes;
                    }

                    this.competition.start_time = value.hours + ':' + value.minutes ;

                    let timeNow = value.hours + ':' + value.minutes;

                    if(timeNow > this.competition.end_time){
                        this.end_time = null;
                        this.competition.end_time = null;
                    }
                    if(timeNow === this.competition.end_time){
                        this.end_time = null;
                        this.competition.end_time = null;
                    }
                }else{
                    this.competition.start_time = null;
                }

                this.checkErrors();
            },

            setEndTime (value) {
                this.errorFront9 = false;

                if(value !== null) {
                    if (value.hours < 10) {
                        value.hours = '0' + value.hours;
                    }

                    if (value.minutes < 10) {
                        value.minutes = '0' + value.minutes;
                    }

                    this.competition.end_time = value.hours + ':' + value.minutes;
                    let timeNow = value.hours + ':' + value.minutes;

                    if (timeNow < this.competition.start_time) {
                        this.start_time = null;
                        this.competition.start_time = null;
                    }
                    if (timeNow === this.competition.start_time) {
                        this.start_time = null;
                        this.competition.start_time = null;
                    }
                }else{
                    this.competition.end_time = null;
                }

                this.checkErrors();
            },
            preventMinusValue(e){
                // this.errorFront6 = false;
                this.checkErrors();
                if(e.target.value === '.'){
                    e.target.value = 0;
                }
                e.target.value = Math.abs(e.target.value);
            },
            checkTimes1(e){
                if(e.target.value > this.competition.end_time){
                    this.competition.end_time = null;
                }
            },
            checkTimes2(e){
                if(e.target.value < this.competition.start_time){
                    this.competition.start_time = null;
                }
            },
            checkDates1(e){
                if(e !== null){
                    let date = new Date(e);
                    if(date.toISOString().split('T')[0] > new Date( this.competition.end_date).toISOString().split('T')[0]){
                        this.competition.end_date = null;
                    }
                    if(date.toISOString().split('T')[0] === new Date( this.competition.end_date).toISOString().split('T')[0]){
                        this.competition.end_date = null;
                    }

                    this.competition.start_date = date.toISOString().split('T')[0];
                }else{
                    this.competition.start_date = null;
                }

                this.checkErrors();
            },
            checkDates2(e){
                if(e !== null){
                    let date = new Date(e);
                    if(date.toISOString().split('T')[0] < new Date( this.competition.start_date).toISOString().split('T')[0]){
                        this.competition.start_date = null;
                    }
                    if(date.toISOString().split('T')[0] === new Date( this.competition.start_date).toISOString().split('T')[0]){
                        this.competition.start_date = null;
                    }

                    this.competition.end_date = date.toISOString().split('T')[0];
                }else{
                    this.competition.end_date = null;
                }

                this.checkErrors();
            },
            clickAssignHandler(event){
                this.isAssignFlag = true;
                this.data = event[1].data.data.data;
                this.chooseMessageText = event[0];
            },
            AssignUsers(){
                // console.log('assigned');
            },

            closeModalHandler(e){
                this.isShow = false;
                this.isAssignFlag = false
            },
            AssignUserToCompetition(){
                this.isShow = true;
                this.confirmModalFlag = true;
                this.confirmMessage = 'Assign to';
            },
            async backHandler () {
                let setDataFlag = this.$store.state.settings.setDataFlag;
                if(setDataFlag){
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                }else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false
                }
            },
            async confirmModalHandler (event) {
                this.isFull = false;
                await this.$store.dispatch('setConfirmModal', false);
                if(event){
                    await this.$store.dispatch('setDataFlag', false);
                    await this.$router.push('/competitions');
                }
            },
            setData(e, type){

            },
            async getTemplates(){
                try{
                    const response = await repository.getTemplates( 'asc',false, 1, true);
                    for(let i = 0 ; i < response.data.data.length ; i++){
                        this.templates.push({label: response.data.data[i].name, value:response.data.data[i].id});
                    }
                }catch(e){
                    // console.log(e);
                }
            },
            checkParticipantType(){
                this.checkErrors();
                // this.errorFront3 = false;
            },
            checkTemplate(){
                this.checkErrors();
                this.errorFront2 = false;
            },
            clearTemplate(e){
                this.errorFront2 = true;
            },
            checkName(){
                this.checkErrors();
                // this.errorFront = false;
            },
            checkErrors(){
                this.errorFront = false;
                this.errorFront2 = false;
                this.errorFront3 = false;
                this.errorFront4 = false;
                this.errorFront5 = false;
                this.errorFront6 = false;
                this.errorFront7 = false;
                this.errorFront8 = false;
                this.errorFront9 = false;
                this.errorFront10 = false;


                if( this.competition.name === '' || this.competition.name === null){
                    this.errorFront = true;
                }

                if(this.competition.template_id === null){
                    this.errorFront2 = true;
                }

                if(this.competition.participant_type === null){
                    this.errorFront3 = true;
                }

                if(+this.competition.date_type === 1){
                    if(this.competition.start_date === null){
                        this.errorFront4 = true;
                    }

                    if(this.competition.end_date === null){
                        this.errorFront5 = true;
                    }

                    if(this.competition.duration === null || this.competition.duration === '' || this.competition.duration === 0){
                        this.errorFront6 = true;
                    }

                }else{
                    if( this.competition.end_date === null){
                        this.errorFront7 = true;
                    }

                    if( this.competition.start_time === null){
                        this.errorFront8 = true;
                    }

                    if( this.competition.end_time === null){
                        this.errorFront9 = true;
                    }

                    if( this.competition.specific_duration === null || this.competition.specific_duration === '' || this.competition.specific_duration === 0){
                        this.errorFront10 = true;
                    }
                }

                this.errorBtnSubmit = this.errorFront || this.errorFront2 || this.errorFront3 ||
                    this.errorFront4 || this.errorFront5 || this.errorFront6 ||
                    this.errorFront7 || this.errorFront8 || this.errorFront9 || this.errorFront10;

                console.log(this.errorBtnSubmit);
            },
            async SaveCompetition(){
                try{
                    if(+this.competition.date_type === 1){
                        if(this.competition.name === null || this.competition.name === "" || this.competition.template_id === null || this.competition.participant_type === null || this.competition.start_date === null || this.competition.end_date === null || this.competition.duration === null || this.competition.duration === '' || this.competition.duration === 0) {
                            // this.errorFront = true;
                            // this.errorFront2 = true;
                            // this.errorFront3 = true;
                            // this.errorFront4 = true;
                            // this.errorFront5 = true;
                            // this.errorFront6 = true;
                            this.checkErrors();
                        }else if(this.competition.start_date === this.competition.end_date){
                            this.showModal = true;
                            this.ImagePath = 'close.png';
                            this.message = 'Start Date Cannot Be Equal End Date';
                        }else{
                            let duration = moment.duration(moment(this.competition.end_date).diff(moment(this.competition.start_date)));
                            let minutesCheck = duration.asMinutes();

                            if(this.competition.duration > minutesCheck){
                                this.showModal = true;
                                this.ImagePath = 'close.png';
                                this.message = 'Check Duration Mintues between start date and end date';
                            }else{
                                const response = await competition.create({
                                    name:this.competition.name,
                                    type:this.competition.type,
                                    participant_type:this.competition.participant_type,
                                    template_id:this.competition.template_id,
                                    date_type:this.competition.date_type,
                                    start_date:this.competition.start_date,
                                    end_date:this.competition.end_date,
                                    start_time:this.firstTimeInDay,
                                    end_time:this.lastTimeInDay,
                                    duration:this.competition.duration
                                });

                                await this.$store.dispatch('setDataFlag', false);
                                this.$router.push({path: '/complete-competitions/'+response.data.data.id});
                            }
                        }
                    }else{
                        if(this.competition.end_date === null || this.start_time === null || this.end_time === null || this.competition.specific_duration === null || this.competition.specific_duration === '' || this.competition.specific_duration === 0) {
                            // this.showModal = true;
                            // this.ImagePath = 'close.png';
                            // this.message = 'Please Fill Data Correctly';

                            // this.errorFront7 = true;
                            // this.errorFront8 = true;
                            // this.errorFront9 = true;
                            // this.errorFront10 = true;

                            this.checkErrors();
                        }else{
                            if(moment(this.competition.end_date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')){
                                // if(moment(this.competition.start_time , 'hh:mm A').format('hh:mm A') <= moment().format('hh:mm A')){
                                //     console.log(moment(this.competition.start_time , 'hh:mm A').format('hh:mm A') , '  ' , moment().format('hh:mm A'));
                                //     this.showModal = true;
                                //     this.ImagePath = 'close.png';
                                //     this.message = 'Please Check Start Time Not Be Before Now';
                                // }else{

                                let startDate = moment(this.competition.end_date).format('YYYY-MM-DD') + 'T' + this.competition.start_time;
                                let endDate = moment(this.competition.end_date).format('YYYY-MM-DD') + 'T' + this.competition.end_time;

                                let startTime = moment.utc(moment(startDate).utc()).format();

                                let endTime = moment.utc(moment(endDate).utc()).format();

                                let diffD = moment.duration(moment(endTime).diff(moment(startTime))).as('minutes');

                                if(diffD <= this.competition.specific_duration){
                                    this.showModal = true;
                                    this.ImagePath = 'close.png';
                                    this.message = 'Check Specific Duration With Start And End Time';
                                }else{
                                    this.competition.duration = this.competition.specific_duration;

                                    const response = await competition.create({
                                        name:this.competition.name,
                                        type:this.competition.type,
                                        participant_type:this.competition.participant_type,
                                        template_id:this.competition.template_id,
                                        date_type:this.competition.date_type,
                                        start_date:this.minToday,
                                        end_date:this.competition.end_date,
                                        start_time:this.competition.start_time,
                                        end_time:this.competition.end_time,
                                        duration:this.competition.duration
                                    });
                                    await this.$store.dispatch('setDataFlag', false);

                                    this.$router.push({path: '/complete-competitions/'+response.data.data.id});
                                }
                                // }
                            }else{
                                this.competition.duration = this.competition.specific_duration;
                                const response = await competition.create({
                                    name:this.competition.name,
                                    type:this.competition.type,
                                    participant_type:this.competition.participant_type,
                                    template_id:this.competition.template_id,
                                    date_type:this.competition.date_type,
                                    start_date:this.minToday,
                                    end_date:this.competition.end_date,
                                    start_time:this.competition.start_time,
                                    end_time:this.competition.end_time,
                                    duration:this.competition.duration
                                });
                                await this.$store.dispatch('setDataFlag', false);

                                this.$router.push({path: '/complete-competitions/'+response.data.data.id});
                            }
                        }
                    }

                }catch(e){
                    console.log(e);
                }
            },
            showRangeDates(e){
                this.competition.date_type = 1;
                this.isActivatedRange = true;
                this.isActivatedSpecific = false;
                this.competition.end_date = null;
                this.start_time = null;
                this.end_time = null;
                this.competition.specific_duration = null;
                this.checkErrors();
            },

            showSpecificDates(){
                this.competition.date_type = 2;
                this.isActivatedRange = false;
                this.isActivatedSpecific = true;
                this.competition.start_date = null;
                this.competition.duration = null;
                this.competition.end_date = null;
                this.checkErrors();
            }
        }
    }
</script>

<style scoped>

    .styleInIPad{
        padding-top: 5rem;
    }

    .designDefaultUser{
        display: none;
        position: absolute;
        right: -115px;
        width: 80%;
        font-size:12px;
        background-color: #021A24;
        color: #fff;
        padding: 0.8em;
        border-radius: 10px;
    }

    .styleDesignCircleInfo{
        cursor: pointer;
    }
    .styleDesignCircleInfo:hover{
        color: #e95626;
    }

    .fontInfoData{
        position: relative;
        right: 80px;
        top: 5px;
    }

    .allowed{
        cursor: pointer;
    }

    .notAllowed{
        cursor: not-allowed;
    }

    .styleCssMargin{
        margin-bottom: 7rem;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }

    ::-webkit-calendar-picker-indicator {
        filter: invert(100%);
    }

    .cssFirstDateOne:focus{
        background-color: #021A24;
        outline: none;
        box-shadow: 0 0 0 0;
        color: #fff;
    }

    .cssFirstDateOne{
        background-color: #021A24;
        color: #fff;
        width:330px;
        padding: 10px;
    }

    .cssSecondDateTwo:focus{
        background-color: #021A24;
        outline: none;
        box-shadow: 0 0 0 0;
        color: #fff;
    }

    .cssSecondDateTwo{
        background-color: #021A24;
        color: #fff;
        width:330px;
        padding: 10px;
    }

    .allCssTime{
        display: flex;
        flex-wrap: wrap;
        justify-content: end;
        align-items: end;
        gap:50px;
    }

    .allCssDate{
        display: flex;
        flex-wrap: wrap;
        gap:50px;
    }

    .styleSecondTime:focus{
        background-color: #021A24;
        outline: none;
        box-shadow: 0 0 0 0;
        color: #fff;
    }

    .styleSecondTime{
        background-color: #021A24;
        color: #fff;
        width: 240px;
        padding: 10px;
        height: 40px;
        border: none;
    }

    .styleFirstTime:focus{
        background-color: transparent;
        box-shadow: 0 0 0 0;
        color: var(--input-search-color);
        width: 240px;
        padding: 10px;
        height: 40px;
        border: 1px solid #fff;
    }

    .styleFirstTime{
        background-color: transparent;
        color: var(--input-search-color);
        width: 240px;
        padding: 10px;
        height: 40px;
    }

    .cssEndDate:focus{
        background-color: #021A24;
        outline: none;
        box-shadow: 0 0 0 0;
        color: #fff;
    }

    .cssEndDate{
        background-color: #021A24;
        color: #fff;
        width:350px;
        padding: 10px;
    }
    .cssRangDates{
        border: 1px solid #04354a;
        padding: 10px;
        width:100%;
    }
    .form-check-input {
        border: 1px solid #e95626 !important;;
        background-color: transparent !important;
    }

    .form-check-input:checked {
        background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e") !important;
        border: 2px solid var(--border-color-data-table) !important;;
        background-color: #e95626 !important;
        box-shadow: 0 0 0 1px #e95626 !important;
    }

    #template_id1{
        background-color: transparent;
        color: var(--input-search-color);
        display: flex;
        flex-wrap: wrap;
        height: 46px;
        width: 100%;
    }
    #template_id2{
        background-color: transparent;
        color: var(--color-template-id);
        padding: 10px;
    }

    .custom-input:focus{
        outline: none;
        box-shadow: 0 0 0 0;
        background-color: transparent;
        color: var(--input-search-color);
    }

    .custom-input{
        background-color: transparent;
        color: var(--input-search-color);
        padding: 10px;
    }
    .styleBtnCss2{
        width: 180px;
        background-color: transparent;
        color: #FFF;
        padding: 8px;
        border-radius: 6px;
        font-weight: bold;
        border: 2px solid #fff;
    }
    .styleBtnCss{
        width: 180px;
        background-color: #E95626;
        color: #FFF;
        padding: 8px;
        border-radius: 6px;
        font-weight: bold;
        border: none;
    }
    .tabcontent2{
        display: block;
        padding-top: 30px;
        padding-bottom: 40px;
        padding-left: 30px;
        height: 50vh;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 15px;
    }

    .errFront{
        position: absolute;
    }

    @media only screen and (max-width: 1300px) and (min-width: 1250px) {
        .tabcontent2{
            height: 59vh;
        }

        .errFront{
            position: relative;
        }

        .styleInIPad{
            padding-top: 0rem;
        }

        .allCssTime{
            justify-content: center;
        }

        .firstCssTime{
            width: 25%;
        }

        .secondCssTime{
            width: 25%;
        }

        .styleFirstTime{
            width: 247px;
        }
    }


    .tabcontent1{
        display: block;
        padding-top: 30px;
        padding-bottom: 40px;
        padding-left: 30px;
        /*height: 20vh;*/
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 15px;
    }
</style>